import { Grid, TextField, Button } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import { useDispatch } from "react-redux";
import { UpdateUsersList } from "../../store/actions";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const AddUser = (props) => {
  const expanded = useCustomState(false);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const name = useCustomState("");
  const lastname = useCustomState("");
  const phoneNumber = useCustomState("");
  // const password = useCustomState("");
  // const confirmPassword = useCustomState("");
  const description = useCustomState("");

  const nameError = useCustomState({ error: false, text: "" });
  const lastnameError = useCustomState({ error: false, text: "" });
  const phoneNumberError = useCustomState({ error: false, text: "" });
  // const passwordError = useCustomState({ error: false, text: "" });
  // const confirmPasswordError = useCustomState({ error: false, text: "" });
  // const descriptionError = useCustomState({ error: false, text: "" });

  const nameChanged = (e) => {
    nameError.handleChange({ error: false, text: "" });
    name.handleChange(e.target.value);
  };
  const lastnameChanged = (e) => {
    lastnameError.handleChange({ error: false, text: "" });
    lastname.handleChange(e.target.value);
  };
  const phoneNumberChanged = (e) => {
    phoneNumberError.handleChange({ error: false, text: "" });
    phoneNumber.handleChange(e.target.value);
  };
  // const passwordChanged = (e) => {
  //   passwordError.handleChange({ error: false, text: "" });
  //   password.handleChange(e.target.value);
  // };
  // const confirmPasswordChanged = (e) => {
  //   confirmPasswordError.handleChange({ error: false, text: "" });
  //   confirmPassword.handleChange(e.target.value);
  // };
  const descriptionChanged = (e) => {
    description.handleChange(e.target.value);
  };

  const dispatch = useDispatch();

  const addUser = (e) => {
    const userName = name.value;
    const userLastname = lastname.value;
    const userPhoneNumber = phoneNumber.value;
    // const userPassword = password.value;
    // const userConfirmPassword = confirmPassword.value;
    let userDescription = description.value;
    let hasError = false;
    // check required fields
    if (userName.length == 0) {
      nameError.handleChange({
        error: true,
        text: "وارد کردن نام کاربر الزامی است.",
      });
      hasError = true;
    }
    if (userLastname.length == 0) {
      lastnameError.handleChange({
        error: true,
        text: "وارد کردن نام خانوادگی کاربر الزامی است.",
      });
      hasError = true;
    }
    if (userPhoneNumber.length == 0) {
      phoneNumberError.handleChange({
        error: true,
        text: "وارد کردن شماره تلفن کاربر الزامی است.",
      });
      hasError = true;
    }
    // if (userPassword.length == 0) {
    //   passwordError.handleChange({
    //     error: true,
    //     text: "وارد کردن رمز عبور الزامی است.",
    //   });
    //   hasError = true;
    // }
    // if (userConfirmPassword.length == 0) {
    //   confirmPasswordError.handleChange({
    //     error: true,
    //     text: "وارد کردن تکرار رمز عبور الزامی است.",
    //   });
    //   hasError = true;
    // }
    if (userDescription.length == 0) {
      userDescription = "وارد نشده";
    }
    if (hasError) {
      return;
    }
    // check phoneNumber Format
    if (userPhoneNumber.length != 11 || isNaN(userPhoneNumber)) {
      phoneNumberError.handleChange({
        error: true,
        text: "فرمت شماره تلفن وارد شده صحیح نمی باشد.",
      });
      hasError = true;
    }
    // check password and confirm password
    // if (userPassword !== userConfirmPassword) {
    //   confirmPasswordError.handleChange({
    //     error: true,
    //     text: "تکرار رمز عبور وارد شده با رمز عبور یکسان نیستند.",
    //   });
    //   hasError = true;
    // }
    if (hasError) {
      return;
    }
    const data = {
      user_name: userName,
      user_phone: userPhoneNumber,
      user_lastname: userLastname,
      user_password: null,
      user_sms_code: null,
      other_information: {
        description: userDescription,
      },
      user_profile: {
        default: "default",
      },
    };
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    Call("POST", "users/admin/add", formData)
      .then((response) => {
        if (response.data.code == 200) {
          dispatch(UpdateUsersList({ updateUsersList: true }));
          name.handleChange("");
          lastname.handleChange("");
          // password.handleChange("");
          // confirmPassword.handleChange("");
          phoneNumber.handleChange("");
          description.handleChange("");
        }
      })
      .catch((error) => {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          if (data.english_message == "phone number already exist.") {
            phoneNumberError.handleChange({
              error: true,
              text: "شماره تلفن وارد شده در حال حاضر در سیستم وجود دارد.",
            });
          }
        }
      });
  };

  return (
    <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"افزودن کاربر جدید"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
                // maxHeight: "320px",
                overflow: "scroll",
              }}
            >
              <Grid
                container
                style={{ paddingTop: "24px", paddingBottom: "24px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={nameError.value.error}
                    helperText={nameError.value.text}
                    onChange={nameChanged}
                    value={name.value}
                    fullWidth
                    variant="standard"
                    label="نام کاربر"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={lastnameError.value.error}
                    helperText={lastnameError.value.text}
                    onChange={lastnameChanged}
                    value={lastname.value}
                    fullWidth
                    variant="standard"
                    label="نام خانوادگی کاربر"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                {/* <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={passwordError.value.error}
                    helperText={passwordError.value.text}
                    onChange={passwordChanged}
                    value={password.value}
                    fullWidth
                    variant="standard"
                    label="رمز عبور"
                    type="password"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={confirmPasswordError.value.error}
                    helperText={confirmPasswordError.value.text}
                    onChange={confirmPasswordChanged}
                    value={confirmPassword.value}
                    fullWidth
                    variant="standard"
                    label="تکرار رمز عبور"
                    type="password"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid> */}

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={phoneNumberError.value.error}
                    helperText={phoneNumberError.value.text}
                    onChange={phoneNumberChanged}
                    value={phoneNumber.value}
                    fullWidth
                    variant="standard"
                    label="شماره تلفن"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    onChange={descriptionChanged}
                    value={description.value}
                    fullWidth
                    variant="filled"
                    multiline
                    rows={8}
                    maxRows={12}
                    label="توضیحات"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Button
                    onClick={addUser}
                    style={{ color: "#fff" }}
                    variant="contained"
                    color="primary"
                  >
                    افزودن
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AddUser;
